import {
  COMMENT,
  INSIGHT_ID,
  ITEMS,
  OPTION_ID,
  POSITION,
  PRIORITIZED_OPTIONS,
  PRIORITY,
  QUESTION_ID,
  RULES,
  SELECTED_OPTION_ID,
  SELECTED_OPTION_IDS,
  SUB_TOPIC_ID,
  TEXT_ANSWER,
  TOPIC_ID,
} from 'constants/formFields';

import type { ICreateInsightAnswersRequest } from 'store/slices/survey/interfaces/IInsightAnswersRequest';
import type { TCreateInsightAnswerSchema } from 'utils/validators/MASurveyValidators';

interface IGetRequestDataForInsightAnswer {
  values: TCreateInsightAnswerSchema,
  recordId?: string,
  status?: string,
}

function getRequestDataForInsightAnswer({
  values,
}: IGetRequestDataForInsightAnswer): ICreateInsightAnswersRequest {
  return {
    [INSIGHT_ID]: values?.[INSIGHT_ID],
    [ITEMS]: values?.[ITEMS]?.map((item) => ({
      [QUESTION_ID]: item[QUESTION_ID],
      ...(item[TEXT_ANSWER] && { [TEXT_ANSWER]: item[TEXT_ANSWER] }),
      ...(item[SELECTED_OPTION_ID] && { [SELECTED_OPTION_ID]: item[SELECTED_OPTION_ID] }),
      ...(Array.isArray(item[SELECTED_OPTION_IDS]) && {
        [SELECTED_OPTION_IDS]: item[SELECTED_OPTION_IDS].filter((id): id is number => id !== undefined),
      }),
      ...(item[PRIORITIZED_OPTIONS] && {
        [PRIORITIZED_OPTIONS]: item[PRIORITIZED_OPTIONS].map((option) => ({
          [PRIORITY]: option[PRIORITY],
          [OPTION_ID]: option[OPTION_ID],
        })),
      }),
      ...(item[COMMENT] && { [COMMENT]: item[COMMENT] }),
    })) || [],
    [RULES]: values?.[RULES]?.map((rule) => ({
      [TOPIC_ID]: rule[TOPIC_ID],
      [SUB_TOPIC_ID]: rule[SUB_TOPIC_ID],
      [POSITION]: rule[POSITION],
    })) || [],
  };
}

export default getRequestDataForInsightAnswer;
